export const eventsTable = {}
